import { css } from "styled-components"

const families = {
  primary: `"Montserrat", "Helvetica", "Arial", sans-serif`,
  secondary: `"Questrial", "Bodoni MT", "Didot", "Didot LT STD", "Hoefler Text", "Garamond", "Times New Roman", serif`,
}

const weights = {
  primary: {
    thin: 300,
    normal: 400,
    medium: 500,
  },
  secondary: {
    normal: 400,
  },
}

const set = (family, weight) => {
  try {
    return css`
      font-family: ${families[family]};
      font-weight: ${weights[family][weight]};
    `
  } catch (e) {
    // eslint-disable-next-line no-console
    return console.error(`Undefined font family/weight`, e.message, e.name)
  }
}

export default {
  set,
}
